var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.groupDialogVisible,
        callback: function ($$v) {
          _vm.groupDialogVisible = $$v
        },
        expression: "groupDialogVisible",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.fromHeader
                        ? _vm.t("groupCreate")
                        : _vm.t("storeConditions")
                    ) +
                    " "
                ),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.groupDialogVisible = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                      [
                        _c("v-row", { staticClass: "ma-0 pa-0 mb-2" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.fromHeader
                                  ? _vm.t("groupEditBodyTitle")
                                  : _vm.t("groupEditStoreConditions")
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 mb-2",
                            attrs: {
                              justify: "space-between",
                              align: "center",
                            },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pr-2",
                                attrs: { cols: "7" },
                              },
                              [
                                _c("v-autocomplete", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    items: _vm.searchResult,
                                    loading: _vm.searchLoading,
                                    "search-input": _vm.search,
                                    "append-icon": "",
                                    color: "white",
                                    dark: "",
                                    "hide-no-data": "",
                                    "hide-selected": "",
                                    outlined: "",
                                    dense: "",
                                    "hide-details": "",
                                    "item-text": "customerName",
                                    placeholder: _vm.tg(
                                      "storeNameInputPlaceholder"
                                    ),
                                    "return-object": "",
                                  },
                                  on: {
                                    "update:searchInput": function ($event) {
                                      _vm.search = $event
                                    },
                                    "update:search-input": function ($event) {
                                      _vm.search = $event
                                    },
                                  },
                                  model: {
                                    value: _vm.storeSearchInputValue,
                                    callback: function ($$v) {
                                      _vm.storeSearchInputValue = $$v
                                    },
                                    expression: "storeSearchInputValue",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "5" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { justify: "space-between" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0 pr-2",
                                        attrs: { cols: "6" },
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              id: "blue_btn",
                                              width: "100%",
                                              height: "2rem",
                                            },
                                            on: {
                                              click: _vm.addToSelectedStore,
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.t("add")))]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "6" },
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              id: "blue_btn",
                                              width: "100%",
                                              height: "2rem",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.filterDialogVisible()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.t("groupEditStoreSearch")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: { justify: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 mt-1 mb-1",
                                attrs: { id: "selected_store_list" },
                              },
                              _vm._l(_vm.selectedStore, function (item, index) {
                                return _c(
                                  "v-col",
                                  {
                                    key: index,
                                    staticClass: "ma-0 pa-0 pl-3 pr-5",
                                    attrs: { id: "store_item" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-2 pt-1 pb-1",
                                        attrs: {
                                          align: "center",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 pl-1",
                                            attrs: { cols: "auto" },
                                          },
                                          [_vm._v(_vm._s(item.customerName))]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "auto" },
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: {
                                                  width: "auto",
                                                  height: "auto",
                                                  id: "back_clean_btn",
                                                  elevation: "0",
                                                  ripple: false,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteStoreName(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("v-img", {
                                                  attrs: {
                                                    "max-height": "1.25rem",
                                                    "max-width": "1.25rem",
                                                    src: require("@/assets/images/close.png"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pt-5 pb-2",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0 mr-2",
                                attrs: {
                                  id: "grey_btn",
                                  width: "8rem",
                                  height: "2rem",
                                },
                                on: { click: _vm.cancelEdit },
                              },
                              [_vm._v(_vm._s(_vm.t("back")))]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  id: "blue_btn",
                                  width: "8rem",
                                  height: "2rem",
                                  loading: _vm.loading,
                                },
                                on: { click: _vm.requestDetermine },
                              },
                              [_vm._v(_vm._s(_vm.t("determine")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("FilterDialog", {
        attrs: {
          dialogVisible: _vm.storeFilterDialogVisible,
          storeDataVisible: true,
          brandBoxVisible: _vm.brandFilterDialogVisible,
          filterVisible: _vm.filterOpenVisible,
        },
        on: { visible: _vm.storeFilterDialogVisibleFunc, edit: _vm.editFunc },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }